import React, { useState } from 'react';
import AppBar from './Components/AppBar';
import Home from './Pages/Home';
import WhoWeAre from './Pages/WhoWeAre'; 
import HowItWorks from './Pages/HowItWorks';
import SafetyTips from '../Shared/Pages/SafetyTips';
import CommunityGuidelines from '../Shared/Pages/CommunityGuidelines';
import PrivacyPolicy from '../Shared/Pages/PrivacyPolicy';
import TermsAndConditions from '../Shared/Pages/TermsAndConditions';

function DesktopHome() {
  const [activePage, setActivePage] = useState('home');

  const handleNavigation = (pageName) => {
    setActivePage(pageName);
  };

  return (
    <div>
      <AppBar onNavigate={handleNavigation} /> 
      {activePage === 'home' && <Home onNavigate={handleNavigation}/>}
      {activePage === 'who-we-are' && <WhoWeAre onNavigate={handleNavigation}/>}
      {activePage === 'how-it-works' && <HowItWorks onNavigate={handleNavigation}/>}
      {activePage === 'safety-tips' && <SafetyTips onNavigate={handleNavigation}/>}
      {activePage === 'community-guidelines' && <CommunityGuidelines onNavigate={handleNavigation}/>}
      {activePage === 'privacy-policy' && <PrivacyPolicy onNavigate={handleNavigation}/>}
      {activePage === 'terms-and-conditions' && <TermsAndConditions onNavigate={handleNavigation}/>}
    </div>
  );
}

export default DesktopHome;
